import {
	AppBar,
	Button,
	Card,
	CardContent,
	Grid,
	LinearProgress,
	Tab,
	Tabs,
	Typography
} from '@material-ui/core';
import { PDFExport } from '@progress/kendo-react-pdf';
import GridItem from 'components/Grid/GridItem.jsx';
import { ParseUriParams } from 'helpers/UriReader';
import { Logout, GetUserToken } from 'helpers/UserHelper';
import { FnaResults } from 'queries/fna/queries';
import React from 'react';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';

import Accrual from './results/Accrual.jsx';
import BalanceSheet from './results/BalanceSheet.jsx';
import CGT from './results/CGT.jsx';
import EstateDuty from './results/EstateDuty.jsx';
import ExecutorsFees from './results/ExecutorsFees.jsx';
import Liquidity from './results/Liquidity.jsx';
import Residue from './results/Residue.jsx';
import ProvisionDeath from './results/DeathProv.jsx';
import ResultsPdf from './ResultsPdf/ResultsPdf';
//import styler from 'stylerjs';

const tabStyle = {
	color: '#6c5cab',
	borderBottom: '2px solid'
};

const tabs = [
	'Balance Sheet',
	'CGT',
	'Estate Duty',
	'Liquidity',
	'Accrual',
	'Residue',
	'Death Provision'
];

class FnaResultsPage extends React.Component {
	

	

	handleChangeTab = (event, value) => 
	{
		this.props.state.tab = value;
		this.props.changeTab();
	};

	exportPDF = () => {
		this.resume.save();
	};

	togglePdfPreview = () => {
		this.setState(prevState => ({ showPdfPreview: !prevState.showPdfPreview }));
	};

	renderToPdf = () => {
		/* 		const htmlstring = ReactDOMServer.renderToStaticMarkup(
			<div className="green">
				<Typography>Hello</Typography>
			</div>
		); */

		const htmlstring = document.getElementById('takeThis').innerHTML;

		console.log('htmlstring:', htmlstring);

		let preClasses = htmlstring.split('class="');
		preClasses.splice(0, 1);
		let postClasses = [];

		for (let i = 0; i < preClasses.length; i++) {
			let classNames = preClasses[i];
			classNames = classNames.split('"')[0];
			const classes = classNames.split(' ');
			postClasses = postClasses.concat([...classes]);
		}

	/* 	console.log('postClasses:', postClasses);

		for (const className of postClasses) {
			var styles = styler('.' + className).get([
				'margin-top',
				'color',
				'font-weight',
				'z-index',
				'font-family',
				'background-color'
			]);
			console.log(`styles for ${className}:`, styles);
		} */
	};

	render() {
		
		var tab = this.props.state.tab

		const balanceSheet = (
			<BalanceSheet state={this.props.state} />
		);
		const CgtSheet = <CGT state={this.props.state} />;


		const EstateDutySheet = (
			<EstateDuty  state={this.props.state}/>
		);

		const LiquiditySheet = (
			<Liquidity state={this.props.state}/>
		);

		const AccrualSheet = <Accrual state={this.props.state} />;

		const ResidueSheet = <Residue state={this.props.state} />;

		const DeathProv = <ProvisionDeath state={this.props.state} />;

		var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname
		return (
			
			

				
						<Grid container style={{ width: "150%", marginLeft: "-25%", marginTop: "25px", flex: 1, height:"fit-content" }}>
							<GridItem xs={12} sm={12} md={10} style={{ margin: 'auto' }}>
								<Card>
									
									<CardContent>
									<CustomCardHeading
										subheading={"Financial Needs Analysis"}
										caption={clientD}
										headline={"Result"}
										/>
										

										<AppBar
											position="static"
											color="default"
											style={{ marginBottom: '20px', marginTop: '-30px' }}
										>
											<Tabs
												tab={tab}
												onChange={this.handleChangeTab}
												indicatorColor="primary"
												textColor="secondary"
												scrollable
												scrollButtons="auto"
											>
												{tabs.map((t, i) => {
													return (
														<Tab label={t} style={i === tab ? tabStyle : {}} />
													);
												})}
											</Tabs>
										</AppBar>

										<Typography variant="title">{tabs[tab]}</Typography>

										{tab === 0 && <div>{balanceSheet}</div>}
										{tab === 1 && <div>{CgtSheet}</div>}
										{tab === 2 && <div>{EstateDutySheet}</div>}
										{tab === 3 && <div>{LiquiditySheet}</div>}
										{tab === 4 && <div>{AccrualSheet}</div>}
										{tab === 5 && <div>{ResidueSheet}</div>}
										{tab === 6 && <div>{DeathProv}</div>}

										
										
									</CardContent>
								</Card>
							</GridItem>
						</Grid>
					
				
			
		);
	}
}
export default FnaResultsPage;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/FnaResultsPage.jsx